/*
  Saffiome ingredient stories. <saffiome-story data-beats="3"> wraps an inline SVG illustration and
  an ordered list of beats (buttons with data-sf-beat="n"). The sequence plays once when the element
  is at least half in view: data-beat 1, 2, 3 at 0, 2600 and 5200 ms, then holds. Tap a beat to jump;
  tap beat 1 after the end to replay. data-idle="on" while on screen so idle loops run only when seen.
  Reduced motion, no IntersectionObserver or no JavaScript: the final beat from the start, no loops.
*/
(function () {
  const STEP_MS = 2600;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  class SaffiomeStory extends HTMLElement {
    connectedCallback() {
      this.beats = Math.max(1, parseInt(this.dataset.beats || '3', 10));
      this.buttons = Array.from(this.querySelectorAll('[data-sf-beat]'));
      this.timers = [];
      this.played = false;
      this.buttons.forEach((b) => b.addEventListener('click', () => this.jump(parseInt(b.dataset.sfBeat, 10))));
      if (reduced.matches || !('IntersectionObserver' in window)) {
        this.setBeat(this.beats);
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.dataset.idle = entry.isIntersecting ? 'on' : 'off';
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && !this.played) this.play();
        });
      }, { threshold: [0, 0.5] });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.clear();
    }

    clear() {
      this.timers.forEach((t) => window.clearTimeout(t));
      this.timers = [];
    }

    play() {
      this.played = true;
      this.clear();
      for (let n = 1; n <= this.beats; n += 1) {
        this.timers.push(window.setTimeout(() => this.setBeat(n), (n - 1) * STEP_MS));
      }
    }

    jump(n) {
      this.clear();
      this.played = true;
      if (n === 1 && parseInt(this.dataset.beat || '0', 10) >= this.beats) {
        this.setBeat(0);
        this.timers.push(window.setTimeout(() => this.play(), 250));
        return;
      }
      this.setBeat(n);
    }

    setBeat(n) {
      this.dataset.beat = String(n);
      this.buttons.forEach((b) => {
        const bn = parseInt(b.dataset.sfBeat, 10);
        b.setAttribute('aria-current', bn === n ? 'step' : 'false');
        b.classList.toggle('is-past', bn < n);
      });
      this.dispatchEvent(new CustomEvent('saffiome:story-beat', { bubbles: true, detail: { beat: n } }));
    }
  }

  if (!customElements.get('saffiome-story')) customElements.define('saffiome-story', SaffiomeStory);
})();
